import React from 'react'
import { Row, Col } from 'reactstrap'
import { withTranslation } from 'react-i18next'
import CinemaCard from '../../components/Cinema/CinemaCard.jsx'
import { processError, arrayUnique, getPaginationInfo } from '../../lib/lib'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import { SquaresFour, Rows, ArrowSquareDown } from 'phosphor-react'
import PropTypes from 'prop-types'
import Skeleton from '../../components/UI/Skeleton'
import Checkbox from '../../components/UI/Checkbox'
const cookies = new Cookies()

class Cinema extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            cinemas: [],
            platforms: [{
                name: 'okko',
                link: 'https://okko.tv/search/',
                checked: false,
            },
            {
                name: 'ivi',
                link: 'https://www.ivi.ru/?ivi_search=',
                checked: false,
            },
            {
                name: 'kinopoisk',
                link: 'https://www.kinopoisk.ru/index.php?kp_query=',
                checked: false,
            },
            {
                name: 'youtube',
                link: 'https://www.youtube.com/results?search_query=',
                checked: false,
            },
            {
                name: 'netflix',
                link: 'https://www.netflix.com/search/',
                checked: false,
            },
            {
                name: 'megogo',
                link: 'https://megogo.ru/ru/search-extended?q=',
                checked: false,
            }],
            genres: [
                {
                    name: '',
                    checked: false,
                },
            ],
            sorts: ['title', 'year', 'genre'],
            render: [],
            page: 1,
            limit: 1000,
            cinemasLoaded: false,
            dataLoaded: false,
        }
        this.sortBy = this.sortBy.bind(this)
        this.squaresFour = this.squaresFour.bind(this)
        this.squaresTwo = this.squaresTwo.bind(this)
        this.showSelector = this.showSelector.bind(this)
        this.filterGenre = this.filterGenre.bind(this)
    }

    getCinemas(data) {
        api.getCinemas(data)
            .then((res) => {
                const genres = res.map(({ genre }) => genre)
                const merged = [].concat.apply([], genres)
                const uniqueGenres = arrayUnique(merged)
                const pureGenres = uniqueGenres.filter((genre) => genre)
                const genreObj = pureGenres.map((genre) => ({ name: genre, checked: false }))
                this.setState({ cinemas: res, cinemasLoaded: true, dataLoaded: true, genres: genreObj, render: res })
            })
            .catch((e) => processError(e, this.props.history))
    }

    componentWillMount() {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page: this.state.page, limit: this.state.limit })
        this.getCinemas({ start, end, lang, token })
    }

    hideSelector(type) {
        document.querySelector(`.custom-select-list-container.${type}`).classList.add('d-none')
    }

    showSelector(e, type) {
        if (this.state.cinemas.length) {
            let arrow = e.target.closest('.cinema-filter-img')
            if (!arrow) arrow = e.target.nextElementSibling
            if (!arrow) return
            if (arrow.id !== type) return
            arrow.classList.toggle('active')
            const select = document.querySelector(`.custom-select-list-container.${type}`)
            select.classList.toggle('d-none')
        }
    }

    filterGenre(name) {
        const genres = this.state.genres.map((genre) => genre.name === name ? ({ name, checked: !genre.checked }) : genre)
        const choosedGenresObj = genres.filter((genre) => genre.checked)
        const choosedGenres = choosedGenresObj.map((genre) => genre.name)
        if (!choosedGenres.length) return this.setState({ genres, render: this.state.cinemas })
        const filteredCinemas = this.state.cinemas.filter((cinema) => cinema.genre && cinema.genre.some((genre) => choosedGenres.includes(genre)))
        this.setState({ genres, render: filteredCinemas })
    }

    sortBy(sort) {
        this.setState({ cinemasLoaded: false })
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        const { start, end } = getPaginationInfo({ page: this.state.page, limit: this.state.limit })
        this.getCinemas({ start, end, lang, token, sort })
    }

    squaresFour(event) {
        event.preventDefault()
        const squaresFour = document.getElementById('squaresFour')
        const squaresTwo = document.getElementById('squaresTwo')
        const cards = document.getElementsByClassName('cinema-card')
        for (let i = 0; i < cards.length; i++) {
            cards[i].classList.remove('col-12', 'col-lg-12', 'col-xl-12', 'col-md-12', 'wide')
            cards[i].classList.add('col-4', 'col-lg-6', 'col-xl-4', 'col-md-6')
        }
        squaresTwo.classList.remove('active')
        squaresFour.classList.add('active')
    }

    squaresTwo(event) {
        event.preventDefault()
        const squaresFour = document.getElementById('squaresFour')
        const squaresTwo = document.getElementById('squaresTwo')
        const cards = document.getElementsByClassName('cinema-card')
        for (let i = 0; i < cards.length; i++) {
            cards[i].classList.remove('col-4', 'col-lg-6', 'col-xl-4', 'col-md-6')
            cards[i].classList.add('col-12', 'col-lg-12', 'col-xl-12', 'col-md-12', 'wide')
        }
        squaresFour.classList.remove('active')
        squaresTwo.classList.add('active')
    }

    render() {
        const { t } = this.props
        return (
            <div>
                <div className="content news-bg position-relative">
                    <Row className="w-100 m-0">
                        <Col xs={12} md={12} className="p-0">
                            <div className="page-title">
                                <div className="float-left">
                                    <h1 className="title news-dashboard xl-font-size">{t('cinema-cinema')}</h1>
                                </div>
                            </div>

                            {
                                this.state.dataLoaded ?
                                    <div className="cinema-menu">
                                        <div className="cinema-filters">
                                            <div className="cinema-filter" onClick={(e) => this.showSelector(e, 'genre')}>
                                                <div className="cinema-filter-content">
                                                    <span className="cinema-filter-desc sm-font-size">{t('cinema-genre-filter')}</span>
                                                    <ArrowSquareDown id="genre" size={20} className="cinema-filter-img" />

                                                    <div className="custom-select-list-container genre d-none">
                                                        <ul className="custom-select-list">
                                                            {this.state.genres.map((genre, index) => (
                                                                <div className="option-wrapper" key={index} onClick={() => this.filterGenre(genre.name)}>
                                                                    <li className="custom-select-list-item sm-font-size">
                                                                        {genre.name}
                                                                    </li>
                                                                    <Checkbox className={'mr-0'} checkboxBg={'bg-inherit'} checked={genre.checked} />
                                                                </div>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <div className="cinema-filter"
                                            // onClick={(e) => this.showSelector(e, 'platform')}
                                            >
                                                <div className="cinema-filter-content">
                                                    <span className="cinema-filter-desc sm-font-size">{t('cinema-platfrom-filter')}</span>
                                                    <ArrowSquareDown id="platform" size={20} className="cinema-filter-img" />

                                                    <div className="custom-select-list-container genre d-none">
                                                        <ul className="custom-select-list">
                                                            {this.state.platforms.map((platform, index) => (
                                                                <div className="option-wrapper" key={index} onClick={() => this.filterPlatform(platform.name)}>
                                                                    <li className="custom-select-list-item sm-font-size">
                                                                        {platform.name}
                                                                    </li>
                                                                    <Checkbox className={'mr-0'} checkboxBg={'bg-inherit'} checked={platform.checked} />
                                                                </div>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="cinema-sort">
                                            <div className="cinema-filter" onClick={(e) => this.showSelector(e, 'sort')}>
                                                <div className="cinema-filter-content">
                                                    <span className="sort-by sm-font-size">{t('cinema-sort')}:</span>
                                                    <span className="cinema-filter-desc sm-font-size">{t('cinema-popularity')}</span>
                                                    <ArrowSquareDown id="sort" size={20} className="cinema-filter-img" />
                                                    <div className="custom-select-list-container sort d-none">
                                                        <ul className="custom-select-list">
                                                            {this.state.sorts.map((sort, index) => (
                                                                <div className="option-wrapper" key={index} onClick={() => {
                                                                    this.sortBy(sort)
                                                                    this.hideSelector('sort')
                                                                }}>
                                                                    <li className="custom-select-list-item sm-font-size">
                                                                        {t(`cinema-sort-${sort}`)}
                                                                    </li>
                                                                    {/* <Checkbox className={'mr-0'} checkboxBg={'bg-inherit'} checked={genre.checked} /> */}
                                                                </div>
                                                            ))}
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                                window.innerWidth >= 768 &&
                                                <div className="cinema-filter">
                                                    <div id="squaresFour" className="btn cinema-btn squares active" onClick={this.squaresFour}>
                                                        <div className="cinema-btn-content">
                                                            <SquaresFour size={20} />
                                                        </div>
                                                    </div>
                                                    <div id="squaresTwo" className="btn cinema-btn squares" onClick={this.squaresTwo}>
                                                        <div className="cinema-btn-content">
                                                            <Rows size={20} />
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    :
                                    <div className="cinema-menu bg-inherit p-0 d-block"><Skeleton height={60} image={true} /></div>
                            }

                            <div className="col-xl-12">
                                <section>
                                    <div className="content-body news-bg">
                                        {' '}
                                        <Row className="px-15">
                                            {
                                                this.state.cinemasLoaded ?
                                                    this.state.render.map((cinema) => (
                                                        <CinemaCard
                                                            key={cinema.id}
                                                            id={cinema.id}
                                                            name={cinema.title}
                                                            year={cinema.year}
                                                            desc={cinema.desc}
                                                            platforms={cinema.platform || this.state.platforms}
                                                            image={cinema.image}
                                                            genre={cinema.genre}
                                                            props={this.props}
                                                        />
                                                    ))
                                                    :
                                                    <React.Fragment>
                                                        <CinemaCard skeleton={true} />
                                                        <CinemaCard skeleton={true} />
                                                        <CinemaCard skeleton={true} />
                                                    </React.Fragment>
                                            }
                                        </Row>
                                    </div>
                                </section>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}

Cinema.propTypes = {
    i18n: PropTypes.object,
    t: PropTypes.func,
    history: PropTypes.object,
}

export default withTranslation()(Cinema)



// WEBPACK FOOTER //
// ./src/views/Cinema/Cinema.jsx